<template>
  <div class="_levitationButton" id="_levitationButton">
    <div class="_contentRootBox" :style="getContentRootBoxStyle()">
      <div class="_contentBox" :style="{'--translateY':!mShow?'0':toTop?'-100%':'100%',...contentStyle}" v-show="!isMove">
        <slot></slot>
      </div>
    </div>
    <div class="_lvBt" :style="lvBtStyle">
      <div style="position: absolute; z-index: 1;width: 100%;height: 100%;" @mousedown.stop="mousedown"
           @click.stop="setShowContent">
      </div>
      <slot name="lvBt" v-on:click.self.prevent style="position: absolute; z-index: -1;" :status="!mShow">
        {{ mShow ? '展开' : '收起' }}
      </slot>
    </div>
  </div>
</template>
<!--参考src/views/szrt_revision/teachingDetail/list/classroom/temporaryInteraction.vue中的使用方式-->
<script>
export default {
  title:'悬浮按钮',
  name: "levitationButton",
  props: {
    contentStyle: {
      type: Object,
      default: () => ({})
    },
    lvBtStyle: {
      type: Object,
      default: () => ({})
    },
    canMove:{//false 则不可拖动
      type:Boolean,
      default:true
    }
  },
  watch:{
    mShow(val){
      this.$emit('btShowChange',!val)
    }
  },
  computed:{
    getContentRootBoxStyle(){
      return function () {
        return this.toTop?{top:'50px'}:{bottom: '50px'}
      }
    }
  },
  data() {
    return {
      mShow: true,
      isMove: false,
      direction: 'top',
      lvBtHeight: 50,
      toTop: false,
      moveEnd:true
    }
  },
  mounted() {
    window.addEventListener('click',()=> this.mShow = true)
    const _levitationButton = document.getElementById('_levitationButton')
    this.lvBtHeight = _levitationButton.offsetHeight
    this.$nextTick(()=>{
      const _contentBox = document.querySelector('._contentBox')
      const _contentRootBox = document.querySelector('._contentRootBox')
      _contentRootBox.style.height = _contentBox.offsetHeight+'px'
    })
  },
  methods: {
    mousedown(lvBtEvent) {
      if (!this.canMove)return;
      // console.log('鼠标按下',[lvBtEvent.target])
      let parentElement = lvBtEvent.target.parentElement.parentElement
      let app = document.getElementById('app')
      let offsetWidth = app.offsetWidth
      let offsetHeight = app.offsetHeight
      const iframes = [...app.querySelectorAll('iframe')]
      iframes.forEach(item => item.style.setProperty('pointer-events', 'none'))
      let mousemove = (appEvent) => {
        this.isMove = true
        this.moveEnd = false
        let parentClientRect = parentElement.getBoundingClientRect()
        let lvBtClientRect = lvBtEvent.target.getBoundingClientRect()
        let x = (appEvent.clientX - parentClientRect.width / 2)
        let y = (appEvent.clientY - parentClientRect.height + lvBtClientRect.height / 2)
        if (x <= 0 || x >= offsetWidth - parentClientRect.width) {
          x = parentClientRect.x
        }

        if (y <= -(parentClientRect.height - lvBtClientRect.height) || y >= offsetHeight - parentClientRect.height) {
          y = parentClientRect.y
        }

        parentElement.style.left = x + 'px'
        parentElement.style.top = y + 'px'

        const _contentRootBox = document.querySelector('._contentRootBox')
        if (y < _contentRootBox.offsetHeight) {
          this.toTop = true;
        } else {
          this.toTop = false;
        }
      }
      app.style.userSelect = 'none'
      window.addEventListener('mouseup', () => {
        // console.log('鼠标抬起')
        this.moveEnd = true
        const iframes = [...app.querySelectorAll('iframe')]
        iframes.forEach(item => item.style.setProperty('pointer-events', 'auto'))
        app.style.userSelect = 'text'
        app.removeEventListener('mousemove', mousemove, true)
      });
      app.addEventListener('mousemove', mousemove, true);
    },
    setShowContent() {
      if (!this.isMove) {
        this.mShow = !this.mShow
      }
      this.isMove = false
    }
  }
}
</script>

<style scoped lang="scss">
::-webkit-scrollbar {
  display: none;
}

._levitationButton {
  position: fixed;
  top: 50%;
  right: 20px;
  width: 150px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 99999;
  user-select: none;
  ._contentRootBox {
    overflow: hidden;
    position: absolute;
    min-height: 100px;
  }
  ._contentBox {
    font-size: 14px;
    position: relative;
    top: 0;
    box-sizing: border-box;
    width: 100%;
    max-height: 300px;
    overflow-y: auto;
    display: grid;
    grid-template-columns: 1fr;
    justify-content: center;
    align-items: center;
    justify-items: center;
    gap: 5px;
    transition: .8s;
    transform: translateY(var(--translateY));
    transform-origin: bottom;
  }
  ._lvBt {
    display: flex;
    width: 50px;
    height: 50px;
    background-color: rgba(235, 239, 243, 0.2);
    box-shadow: 0 0 4px rgba(79, 78, 78, 0.2);
    border-radius: 10px;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    backdrop-filter: blur(5px);
  }
}

</style>



// WEBPACK FOOTER //
// src/views/component/LevitationButton.vue